import {Component, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {Group, SJC} from "../../../data/types/groups/types";
import {Make} from "../../../data/types/makes/types";
import {ALL_MAKES_SELECT, DEFAULT_SELECTED_MAKE} from "../../../const";
import {FormsModule} from "@angular/forms";
import {InputTextareaModule} from "primeng/inputtextarea";
import {DropdownModule} from "primeng/dropdown";
import {FileUpload, FileUploadHandlerEvent, FileUploadModule} from "primeng/fileupload";
import {NgIf} from "@angular/common";
import {ImageUploaderService} from "../../../data/services/image-uploader.service";
import {catchError, throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {MessageService} from "primeng/api";

@Component({
    selector: 'app-image-upload',
    standalone: true,
    imports: [
        DialogModule,
        FormsModule,
        InputTextareaModule,
        DropdownModule,
        FileUploadModule,
        NgIf,
    ],
    templateUrl: './image-upload.component.html',
    styleUrl: './image-upload.component.css'
})
export class ImageUploadComponent {
    @ViewChild('fileUpload') fileUpload!: FileUpload;

    @Input() group!: Group
    @Input() makes!: Make[]
    @Input() sjcs: SJC[] = [];

    @Output() onImageUploadEvent = new EventEmitter<boolean>()

    imageUploader = inject(ImageUploaderService)
    messageService = inject(MessageService);

    loading: boolean = false;

    selectedMake: Make | undefined = DEFAULT_SELECTED_MAKE;
    selectedSjc: SJC | undefined;
    customCaption: string = ''
    protected readonly ALL_MAKES_SELECT = ALL_MAKES_SELECT;

    onUpload(event: FileUploadHandlerEvent) {
        this.loading = true
        const file = event.files[0];
        const formData = new FormData();

        formData.append('file', file, file.name);
        formData.append('caption', this.customCaption);
        formData.append('sjc_group_id', this.group.id.toString());
        formData.append('sjc_group_name', this.group.name.toString());

        if (this.selectedSjc) {
            formData.append('custom_sjc_id', this.selectedSjc.id.toString());
        }

        if (this.selectedMake) {
            formData.append('make_id', this.selectedMake!.id.toString());
        }

        this.imageUploader.uploadImage(formData).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe(
            (response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'File uploaded successfully'
                });
                this.fileUpload.clear()
                this.loading = false;
                this.onImageUploadEvent.emit(true)
            },
        );
    }

    handleError(error: HttpErrorResponse) {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'File upload failed'});
        this.loading = false;
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

    onMakesClear() {
        this.selectedMake = ALL_MAKES_SELECT;
    }
}
